// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"2b69be57","792":"6dd72c98"}[chunkId] + ".chunk.js";
};